import { useFormContext, Controller } from 'react-hook-form';
import styles from '../../index.module.scss';
import { FormControl } from '@mui/material';
import { ReactComponent as ExpandMoreIcon } from '../../../../../../../../../assets/icons/patientProfileIcons/expandMoreIcon.svg';
import classNames from 'classnames';
import Select from '../../../../../../../../Inputs/Select';
import { K_LEVEL_OPTIONS } from '../../../../../hooks/intake-options';
import { useTranslation } from 'react-i18next';
import { DEFAULT_NS } from '../../../../../../../../../i18n/types';

const KLevelField = () => {
  const { control } = useFormContext();
  const { t } = useTranslation(DEFAULT_NS, {
    keyPrefix: 'profile.content.fields',
  });

  return (
    <FormControl
      className={classNames(
        styles.inputWrapper,
        styles.selectWrapper,
        styles.largeInputWrapper
      )}>
      <Controller
        name="kLevel"
        control={control}
        render={({ field }) => (
          <Select
            options={K_LEVEL_OPTIONS}
            label={t('kLevel')}
            {...field}
            IconComponent={ExpandMoreIcon}
            classes={{
              select: styles.inputField,
              icon: styles.selectIcon,
            }}
            className={styles.selectRoot}
            disableUnderline
            displayEmpty={true}
            renderValue={(value) => (
              <div
                className={classNames(styles.selectValue, {
                  [styles.placeholder]: value === '',
                })}>
                {K_LEVEL_OPTIONS.find((option) => option.value === value)
                  ?.label || 'Select level'}
              </div>
            )}
          />
        )}
      />
    </FormControl>
  );
};
export default KLevelField;
